export default __webpack_public_path__ + "static/media/2.692657f2.png";